import React from 'react'
import './App.css'
import './Ticketdownload.css'
import { Redirect } from 'react-router-dom'
import Axios from 'axios'
import TopBarProgress from 'react-topbar-progress-indicator'
import Modal from 'react-bootstrap/Modal'
import NumberFormat from 'react-number-format'
import { BiMenu, BiShieldAlt2 } from 'react-icons/bi'
import Header5 from './components/Header5'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import SideNavCust from './layouts/SideNavCust'
import { API_URL } from './config'
var QRCode = require('qrcode.react')

class Ticketdownload extends React.Component {
  constructor(props) {
    super(props)
    const isMobile = window.innerWidth <= 768
    this.state = {
      details: [],
      loadBarProgress: true,
      resumeModal: false,
      isMobile,
      collapsed: isMobile,
    }
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
    const businessname = localStorage.getItem('businessname')
    const eventid = localStorage.getItem('eventid')
    document.title = 'Ticket print - ' + businessname
    const ticketLimit = localStorage.getItem('ticketLimit')

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=TICKETREADYTODOWNLOAD&eventid=${eventid}&ticketLimit=${ticketLimit}&reprint=${localStorage.getItem(
        'ticketPrint',
      )}`,
      { withCredentials: true },
    )
      .then((response) => {
        if (response.data.val == 0) {
          this.setState({ details: [], loadBarProgress: false })
        } else {
          this.setState({ details: response.data, loadBarProgress: false })
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ loadBarProgress: false })
      })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  titleCase = (str) =>
    String(str || '')
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')

  signature = (payload) => {
    const part = String(payload || '').split('.')[1]
    return part ? part.slice(0, 8) : ''
  }

  typeLabel = (category) => {
    const key = String(category || '')
      .trim()
      .toLowerCase()
    return key === 'vip' ? 'VIP' : key === 'vvip' ? 'VVIP' : 'General'
  }

  renderTicket = (item, index) => {
    const businessname = localStorage.getItem('businessname')
    const isKid = parseInt(item.age_group) === 1
    const price = Number(isKid ? item.kids_price : item.price).toFixed(2)
    const venueLines = String(item.venue || '')
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean)

    // watermark sits only in the empty space beside the pill and the time
    const mark = (
      <span
        className="tk-mark"
        aria-hidden="true"
        style={{ backgroundImage: `url("${API_URL}/logok.png")` }}
      />
    )

    const field = (label, value, cls) => (
      <div className={`tk-field${cls ? ' ' + cls : ''}`}>
        <span className="tk-k">{label}</span>
        <span className="tk-v">{value}</span>
      </div>
    )

    return (
      <article className="tk" key={item.ticketnumber || index}>
        {/* LEFT: event info */}
        <aside className="tk-info">
          <div>
            <div className="tk-row">
              <span className="tk-pill">Event dates</span>
              {mark}
            </div>
            <div className="tk-date">
              {item.eventdate} {item.eventmonth}, {item.eventyear}
            </div>
          </div>

          <div className="tk-row">
            <div>
              <span className="tk-k">Time</span>
              <span className="tk-v">
                {item.starttime} - {item.finishtime}
              </span>
            </div>
            {mark}
          </div>

          <div>
            <span className="tk-k">Venue</span>
            <span className="tk-v">
              {venueLines.map((line, i) => (
                <span className="tk-line" key={i}>
                  {line}
                </span>
              ))}
            </span>
          </div>

          <div className="tk-powered">
            <div className="tk-brand">
              <span>Powered by</span>
              <img
                src={`${API_URL}/malelogo.png`}
                alt="Karamale"
                onError={(e) => {
                  e.currentTarget.style.display = 'none'
                  if (e.currentTarget.nextSibling)
                    e.currentTarget.nextSibling.style.display = 'inline'
                }}
              />
              <b className="tk-wordmark">
                karamale<i>.</i>
              </b>
            </div>
            <p>
              <b>WhatsApp:</b> +27 66 561 6528
            </p>
          </div>
        </aside>

        {/* CENTER: title + details */}
        <div className="tk-main">
          <header className="tk-head">
            <div className="tk-head-text">
              <h3>{this.titleCase(localStorage.getItem('eventname'))}</h3>
              <p>Hosted by {item.organiserName || businessname}</p>
            </div>
            <span className="tk-num">{index + 1}</span>
          </header>

          <div className="tk-grid">
            <section className="tk-cell">
              <h4>Customer details</h4>
              <div className="tk-two">
                {field('Issued to', 'Customer')}
                {field('Ticket holder', 'Customer')}
              </div>
            </section>

            <section className="tk-cell">
              <h4>Cost details</h4>
              <div className="tk-two">
                {field('Ticket price', `R${price}`)}
                {field('Total', `R${price}`)}
              </div>
            </section>

            <section className="tk-cell">
              <div className="tk-two">
                {field('Type', <span className="tk-type">{this.typeLabel(item.category)}</span>)}
                {field('Admission', '1')}
              </div>
            </section>

            <section className="tk-cell">
              {field("Organiser's email", item.organiser_email, 'tk-email')}
            </section>

            <section className="tk-cell tk-secure">
              <BiShieldAlt2 size={20} />
              {field('Security Notice', 'Do not share this ticket publicly')}
            </section>

            <section className="tk-cell">
              {field('Signature', this.signature(item.qr_payload), 'tk-mono')}
            </section>
          </div>
        </div>

        {/* RIGHT: QR stub */}
        <aside className="tk-qr">
          <span className="tk-scan">Scan Here</span>
          <div className="tk-qr-box">
            <QRCode value={item.qr_payload} logoSize={0} size={100} />
          </div>
          <span className="tk-code">{item.ticketnumber}</span>
          <span className="tk-age">{item.age_group == 1 ? 'Child' : 'Adult'}</span>
        </aside>
      </article>
    )
  }

  details = () => {
    const { details, loadBarProgress } = this.state

    if (loadBarProgress) {
      return <div className="tkp-empty">Loading tickets…</div>
    }

    if (details.length < 1) {
      return (
        <div className="tkp-empty">
          Your tickets are already printed.
          <br />
          If this is not the case, please dial <b>+27 78 236 5403</b> for assistance.
        </div>
      )
    }

    return (
      <div className="tkp-list">{details.map((item, index) => this.renderTicket(item, index))}</div>
    )
  }

  confirm = () => {
    this.setState({ resumeModal: true })
  }

  download = () => {
    this.props.history.push({
      pathname: '/download',
      state: {
        reprint: 'no',
      },
    })
  }

  closeModal = () => {
    this.setState({ resumeModal: false })
  }

  cancel = () => {
    this.setState({ resumeModal: false })
  }

  render() {
    if (localStorage.getItem('businessid') === null) {
      return <Redirect to="/login" />
    }

    const accounttype = localStorage.getItem('accounttype')
    const { collapsed, isMobile, loadBarProgress } = this.state
    const ticketPrint = localStorage.getItem('ticketPrint')

    return (
      <div className="view">
        {loadBarProgress && <TopBarProgress />}
        {accounttype === 'customer' ? (
          <>
            <SideNavCust collapsed={collapsed} onToggle={this.handleToggle} />
            <Header />
          </>
        ) : accounttype === 'business' ? (
          <>
            <SideNav collapsed={collapsed} onToggle={this.handleToggle} />
            <Header />
          </>
        ) : (
          <Header5 />
        )}
        <div
          className="main-content"
          style={{
            marginTop: 40,
            marginLeft: isMobile ? '0px' : collapsed ? '60px' : '240px',
          }}
        >
          {isMobile && !collapsed && (
            <div className="mobile-overlay active" onClick={this.handleToggle} />
          )}

          {isMobile && collapsed && (
            <label className="mobile-toggle" onClick={this.handleToggle}>
              <BiMenu size={25} />
            </label>
          )}

          <Modal show={this.state.resumeModal} onHide={this.closeModal} centered>
            <div className="tkm">
              <h3>Download tickets</h3>
              <p>
                <b>R{Number(localStorage.getItem('costs')).toFixed(2)}</b> will be deducted from
                your current balance, and your balance is{' '}
                <b>
                  <NumberFormat
                    thousandsGroupStyle="thousand"
                    value={localStorage.getItem('balance')}
                    prefix="R"
                    decimalSeparator="."
                    displayType="text"
                    type="text"
                    thousandSeparator={true}
                    fixedDecimalScale={true}
                  />
                </b>
                .
              </p>
              <p>Are you sure you want to download these tickets?</p>
              <div className="tkm-actions">
                <button type="button" className="tkm-cancel" onClick={() => this.cancel()}>
                  Cancel
                </button>
                <button type="button" className="tkm-go" onClick={() => this.download()}>
                  Download
                </button>
              </div>
            </div>
          </Modal>

          <div className="tkp">
            <div className="tkp-shell">
              <section className="tkp-head">
                <div className="tkp-head-top">
                  <div>
                    <span className="tkp-kicker">Ticket print</span>
                    <h1>{this.titleCase(localStorage.getItem('eventname'))}</h1>
                  </div>
                  <button type="button" className="tkp-cta" onClick={() => this.confirm()}>
                    Download
                  </button>
                </div>

                <div className="tkp-stats">
                  <div className="tkp-stat">
                    <span>Number of tickets prepared</span>
                    <strong>{ticketPrint}</strong>
                  </div>
                  <div className="tkp-stat">
                    <span>Estimated revenue after sales</span>
                    <strong>R{localStorage.getItem('estimatedRevenue')}</strong>
                  </div>
                  <div className="tkp-stat">
                    <span>Cost per ticket print</span>
                    <strong>R1.0</strong>
                  </div>
                  <div className="tkp-stat">
                    <span>Total cost for {ticketPrint} tickets print</span>
                    <strong>R{localStorage.getItem('costs')}</strong>
                  </div>
                </div>
              </section>

              <h2 className="tkp-section">{ticketPrint} tickets ready to download</h2>

              {this.details()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Ticketdownload
